import { render, staticRenderFns } from "./AgeRating16.vue?vue&type=template&id=3b2963b6"
import script from "./AgeRating16.vue?vue&type=script&lang=js"
export * from "./AgeRating16.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports